// Check for the element every 10 milliseconds
// 1. Find the URL meta tag
const ogUrlMeta = document.querySelector('meta[property="og:url"]');

// 2. Check if the current page matches your exclusion rules
const isExcludedPage = ogUrlMeta && (
    ogUrlMeta.content === 'https://artemstone.com/collections/all' || 
    ogUrlMeta.content.startsWith('https://artemstone.com/products')
);
    if (!isExcludedPage) {
    const checkInterval = setInterval(function() {
        const accountEl = document.querySelector('shopify-account');
        
        // If the element and its shadowRoot finally exist...
        if (accountEl && accountEl.shadowRoot) {
            
            const customStyles = document.createElement('style');
            
            customStyles.innerHTML = `
                .account-button__avatar-initials { color: var(--my-avatar-color) !important; }
                .account-button__avatar { transition: var(--my-avatar-transition, none) !important; }
                .account-button__avatar { box-shadow: var(--my-avatar-shadow) !important; }
                .header-actions__cart-icon { color: white !important; }
            `;
            
            // Inject the styles
            accountEl.shadowRoot.appendChild(customStyles);
            
            // Stop checking now that we are done
            clearInterval(checkInterval); 
        }
    }, 10);

    // Safety fallback: Stop checking after 5 seconds just in case the element never loads
    setTimeout(function() {
        clearInterval(checkInterval);
    }, 5000);
}